<template>
    <div class="row">
        <div class="col-12 mb-1">
            <label class="form-label">Dosya Türü</label>
            <v-validator :errors="errors" parameter="SystemCode" :watch="type">
                <v-select-list :options="types" v-model="type" label="Name" :disabled="types.length == 0" placeholder="Dosya Türü"></v-select-list>
            </v-validator>
        </div>
        <div class="col-12">
            <label class="form-label">Dosya</label>
            <v-validator :errors="errors" parameter="File" :watch="value.File">
                <file-uploader :accept="['pdf', 'png', 'jpg', 'jpeg', 'docx', 'doc']" :value="value" valueParameter="File"></file-uploader>
            </v-validator>
        </div>
    </div>
</template>

<script>
import FileUploader from "@/components/v-file-uploader/VFileUploader.vue";

export default {
    components: {
        FileUploader,
    },
    props: {
        value: Object,
        errors: Object,
        types: {
            type: Array,
            default: () => [],
        },
    },
    computed: {
        type: {
            get: function () {
                return this.types.find((b) => b.SystemCode == this.value.SystemCode);
            },
            set: function (value) {
                this.value.SystemCode = value?.SystemCode || null;
            },
        },
    },
};
</script>

<style></style>
